import {Resource} from "../resources/resource";
import { client } from "clientInstance";

export function uploadLogo<T extends Resource>(resource: T, logo: File) {
    const fd = new FormData();
    fd.append("fileToUpload", logo);
    return client.post(resource.Links["Logo"], fd);
}

export async function saveLogo<T extends Resource>(resource: T, file: File, reset: boolean) {
    // Important: when using saveLogo
    // We upload the logo first so that when we do the model save we get back a new url for logo
    if (file) {
        return await uploadLogo(resource, file);
    } else if (reset) {
        return await uploadLogo(resource, null);
    }
}
